import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {InputNumber} from 'antd';
import Card from '../../../Card';

const StyledCardDetailsPanel = styled.div`
  .ant-alert {
    align-items: baseline;
  }
`;

const StyledCardDetailsPanelCard = styled(Card)`

  .card-details {
    margin-bottom: 16px;
  }

  .card-banner {
    margin-bottom: 8px;
  }

  .ant-card-actions {
    justify-content: end;
    padding: 16px 24px;

    li {
      margin: 0;
      width: unset !important;
      &:not(:last-child) {
        border-inline-end: none;
        margin-right: 16px;
      }
    }
  }
`;

const StyledCardDetailsPanelInput = styled(InputNumber)`
  width: 100%;
  height: 38px;

  .ant-input-number-group-addon {
    background-color: transparent;
    svg {
      width: 16px;

      path {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

const StyledCardDetailsPanelLink = styled(Link)`
  align-items: center;
  border-radius: ${props => props.theme.border_radius.standard};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  height: 36px;
  padding: 8px;
  transition: .2s;

  .link-icon {
    svg {
      path {
        fill: ${props => props.theme.colors.neutral_10};
      }
    }
  }

  &:hover {
    background-color: ${props => props.theme.colors.neutral_2};
    color: ${props => props.theme.colors.neutral_10};
  }
`;

export {
  StyledCardDetailsPanel,
  StyledCardDetailsPanelCard,
  StyledCardDetailsPanelInput,
  StyledCardDetailsPanelLink,
}
